import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const TooltipTime = styled.time`
  color: ${color("text-medium")};
  font-size: 0.875em;
`;
